import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./i18n";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
